import ContentPage from '@/components/feature/ContentPage';

export default function TermsPage() {
  return (
    <ContentPage
      title="Terms of Use"
      metaTitle="Terms of Use | CSSBuyBR.TOP"
      metaDescription="CSSBuyBR.TOP terms of use. Read our terms and conditions for using this independent resource website."
      content={
        <div className="space-y-6">
          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Acceptance of Terms</h2>
            <p>By accessing and using CSSBuyBR.TOP, you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use this website.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Independent Resource</h2>
            <p>CSSBuyBR.TOP is an independent resource website. We are not affiliated with, sponsored by, or officially endorsed by CSSBuy or any related entity. All content is provided for informational and educational purposes only.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Content Accuracy</h2>
            <p>We strive to provide accurate and up-to-date information, but we do not guarantee the completeness, accuracy, or reliability of any content on this site. Information about third-party services, prices, shipping costs, and policies may change without notice. Always verify current information directly with official sources.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">No Guarantees</h2>
            <p>We do not guarantee:</p>
            <ul className="list-disc list-inside space-y-1.5 ml-2 mt-2">
              <li>Specific search engine rankings or traffic results</li>
              <li>The quality, safety, or legitimacy of any third-party service</li>
              <li>That any coupon, discount, or promotional information is current or valid</li>
              <li>Specific shipping costs, times, or outcomes</li>
              <li>That any linked website is safe, secure, or trustworthy</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">External Links</h2>
            <p>This website contains links to external websites, including our main site at kaspreadsheet.com. We are not responsible for the content, practices, or policies of any third-party websites. Visiting external links is at your own risk.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Intellectual Property</h2>
            <p>All content on this website, including text, images, and design elements, is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works without permission.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, CSSBuyBR.TOP and its operators shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of this website or reliance on any information provided.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Changes to Terms</h2>
            <p>We may update these terms at any time. Continued use of the website after changes constitutes acceptance of the updated terms. Please review this page periodically.</p>
          </section>

          <section>
            <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-3">Governing Law</h2>
            <p>These terms are governed by applicable laws. Any disputes arising from these terms shall be resolved in accordance with the laws of the jurisdiction where the website operator is located.</p>
          </section>

          <p className="text-sm text-foreground-500 italic">Last updated: August 26, 2026</p>
        </div>
      }
    />
  );
}